/* eslint-disable no-shadow */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { Editor } from "react-draft-wysiwyg";
import { EditorState, ContentState, convertFromHTML } from "draft-js";
import { stateToHTML } from "draft-js-export-html";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { submitUpdate } from "../../../actions/agencyProfileActions";
import Warning from "./Warning";
import {
  Wrapper,
  CloseButton,
  Form,
  EditorWrapper,
  Buttons,
  SaveButton,
} from "./styles/about-me-edit-styles";

export class AboutMeEdit extends Component {
  constructor(props) {
    super(props);
    const { aboutAgent } = this.props;

    this.state = {
      editorState: aboutAgent
        ? EditorState.createWithContent(
            ContentState.createFromBlockArray(convertFromHTML(aboutAgent))
          )
        : "",
      aboutAgent,
      warningActive: false,
    };
  }

  onEditorStateChange = (editorState) => {
    this.setState({
      editorState,
    });
  };

  toggleWarning = () => {
    this.setState(({ warningActive }) => ({ warningActive: !warningActive }));
  };

  editorOnChange = (editorState) => {
    let html = stateToHTML(editorState.getCurrentContent());
    if (html === "<p><br></p>") {
      html = "";
    }
    this.setState({ aboutAgent: html });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { submitUpdate, userId, toggleEditAboutMe } = this.props;
    const { aboutAgent } = this.state;

    submitUpdate({ aboutAgent, userId }, toggleEditAboutMe, "ABOUT_ME");
  };

  render() {
    const { toggleEditAboutMe } = this.props;
    const { warningActive, editorState } = this.state;

    return (
      <Wrapper>
        {warningActive && (
          <Warning
            toggleWarning={this.toggleWarning}
            closeForm={toggleEditAboutMe}
          />
        )}
        <CloseButton onClick={() => this.toggleWarning()}>
          <FontAwesomeIcon icon={faTimes} />
        </CloseButton>
        <Form>
          <EditorWrapper>
            <Editor
              ref={this.editor}
              toolbarClassName="editor-toolbar"
              editorClassName="editor"
              editorState={editorState}
              onEditorStateChange={this.onEditorStateChange}
              onChange={() => this.editorOnChange(editorState)}
              toolbar={{
                options: ["inline", "list"],
                inline: {
                  options: ["bold", "italic", "underline", "strikethrough"],
                },
                list: {
                  options: ["unordered", "ordered"],
                },
              }}
            />
          </EditorWrapper>
          <Buttons>
            <SaveButton
              data-test-id="about-me-save-button"
              onClick={this.handleSubmit}
            >
              save
            </SaveButton>
          </Buttons>
        </Form>
      </Wrapper>
    );
  }
}

AboutMeEdit.propTypes = {
  toggleEditAboutMe: PropTypes.func.isRequired,
  submitUpdate: PropTypes.func.isRequired,
  aboutAgent: PropTypes.string,
  userId: PropTypes.string,
};

AboutMeEdit.defaultProps = {
  aboutAgent: PropTypes.isNull,
  userId: PropTypes.isNull,
};

const mapStateToProps = (state) => ({
  aboutAgent: state.agencyProfile.profileData.aboutAgent,
  userId: state.agencyProfile.profileData.user.id,
});

export default connect(mapStateToProps, { submitUpdate })(AboutMeEdit);
